$(document).ready(function(){
  $(document).on('change', '.hotel-tabs', function(){
    var p = $(this).prop('checked');
    var id = $(this).attr('data-id');
    //console.log(id);
    $('.tab-content').removeClass('on');
    $('#tab-content-'+id).addClass('on');
  });
  
  $(document).on('click', '#aggrement_text a', function(){
    var url = $(this).attr('href');
    window.open(url, "_blank");
    return false;
  });
  
  var imgServerURL = window.imgServerURL;
  var serverURL = window.serverURL;
  
  function checkNumber(){
    
  } 
  function generateFinalTotal(totalArr){
    var t = 0;
    //console.log(totalArr);
    for(var total in totalArr){
      //console.log(total);
      //console.log(totalArr[total]);
      t = t + totalArr[total];
      //console.log(t);
    }
    //console.log(t);
    t = t*100;
    if(t > 0){
      $("#accept_terms").removeAttr("disabled");
    }else{
      $("#accept_terms").attr("disabled", true);
    }
    $('.final-total span').text( Shopify.formatMoney(t, theme.moneyFormat));
  }

  function getQueryStringParameters() {
    var parameters = {}, hash;
    var q = document.URL.split('?')[1];
    if(q != undefined) {
      q = q.split('&');
      for(var i = 0; i < q.length; i++) {
        hash = q[i].split('=');
        parameters[hash[0]] = hash[1];
      }
    }
    return parameters;
  }
  
  function isEmpty(obj) {
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }
  
  function isAppleDevice() {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad|Apple)/) != null) {
      return true;
    }
    return false;
  }

  function apple_date(date){
    var d = date;
    var dateParts = d.substring(0,10).split('-');
    var timePart = d.substr(11);
    d = dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0] + ' ' + timePart;

    var newDate = new Date(d);
    return newDate;
  }
  
  $.ajax({
    url: serverURL+"api/get_main_event",
    type: "GET",
    beforeSend: function() {
      // setting a timeout
      $('body').addClass('loader');
    },
    data: $.param({product_id:window.productID }),
    dataType: 'json',
    crossDomain:true,
    success: function(response){
      console.log(response);
      //var fields = JSON.parse(response);
      var d = response.data;      
      $('.product-description').html(d.event_description);
      $('.productMeta .artist_block').find('p').html(d.event_artistname);
      $('.productMeta .location_block').find('p').html(d.event_location);
      
      var todayDate = new Date();
      
      /* Product Images and Thumbnail */
      $('.productLeft').append('<div class="slider-container"><div id="sync1" class="slider-for owl-carousel"></div><div id="sync2" class="slider-to owl-carousel"></div></div>');
      var productimages = d.event_images;
      if(productimages != ''){
        var imagearray = productimages.split(",");
        for(var i = 0; i < imagearray.length; i++){
           var image = "https://app.nationalconcerts.com/"+imagearray[i];
           //console.log(image);
           $('.slider-for').append('<div class="item"><img class="item-slick" src="'+image+'"></div>');
           $('.slider-to').append('<div class="item"><img class="item-slick" src="'+image+'"></div>');
        }
     	
        var sync1 = $("#sync1");
        var sync2 = $("#sync2");

        sync1.owlCarousel({
          singleItem : true,
          autoPlay : true,
          slideSpeed : 1000,
          navigation: true,
          pagination:true,
          afterAction : syncPosition,
          responsiveRefreshRate : 200,
        });

        sync2.owlCarousel({
          items : 5,
          itemsDesktop      : [1199,10],
          itemsDesktopSmall     : [979,10],
          itemsTablet       : [768,8],
          itemsMobile       : [479,4],
          pagination:true,
          responsiveRefreshRate : 100,
          afterInit : function(el){
            el.find(".owl-item").eq(0).addClass("synced");
          }
        });

        function syncPosition(el){
          var current = this.currentItem;
          $("#sync2")
          .find(".owl-item")
          .removeClass("synced")
          .eq(current)
          .addClass("synced")
          if($("#sync2").data("owlCarousel") !== undefined){
            center(current)
          }
        }

        $("#sync2").on("click", ".owl-item", function(e){
          e.preventDefault();
          var number = $(this).data("owlItem");
          sync1.trigger("owl.goTo",number);
        });

        function center(number){
          var sync2visible = sync2.data("owlCarousel").owl.visibleItems;
          var num = number;
          var found = false;
          for(var i in sync2visible){
            if(num === sync2visible[i]){
              var found = true;
            }
          }

          if(found===false){
            if(num>sync2visible[sync2visible.length-1]){
              sync2.trigger("owl.goTo", num - sync2visible.length+2)
            }else{
              if(num - 1 === -1){
                num = 0;
              }
              sync2.trigger("owl.goTo", num);
            }
          } else if(num === sync2visible[sync2visible.length-1]){
            sync2.trigger("owl.goTo", sync2visible[1])
          } else if(num === sync2visible[0]){
            sync2.trigger("owl.goTo", num-1)
          }
        }
      }
     
      /* Product Date */
      var eventDate = new Date(d.event_startdate);
      
      if (isAppleDevice()) {
        var myDate = d.event_startdate;
        var dateParts = myDate.substring(0,10).split('-');
        var timePart = myDate.substr(11);
        myDate= dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0] + ' ' + timePart;
        
        eventDate = new Date(myDate);
      }
      
      var month = new Array();
      month[0] = "January";
      month[1] = "February";
      month[2] = "March";
      month[3] = "April";
      month[4] = "May";
      month[5] = "June";
      month[6] = "July";
      month[7] = "August";
      month[8] = "September";
      month[9] = "October";
      month[10] = "November";
      month[11] = "December";
      
      $('.event_date .date').text(eventDate.getDate());
      $('.event_date .month').text(month[eventDate.getMonth()]);
      $('.event_date .year').text(eventDate.getFullYear());
      
      var parameters = getQueryStringParameters();
      var hasValid = false;
      var id = 0;
      
      var hasNewReq = true;
      var hasApprove = false;
      
      if(isEmpty(parameters) == false) {
        var isId = false;
        $.each(parameters, function(key, value) {
          if(key == 'id'){
            isId = true;
            hasValid = true;
            id = value;
          }
        });
      }
      
      console.log(isId);
      
      if(isEmpty(parameters) == true || isId == false) {
        var fieldHtml = '';
        $(d.fields).each(function(k,v){
          if(v.status != '0'){
            fieldHtml += '<div class="form-group" ><label class="hide" for="'+v.id+'-'+k+'">'+v.label+'</label><input class="form-control" data-label="'+v.label+'" name="details['+v.id+']" placeholder="'+v.label+'" data-validation="'+v.validation+'" type="text"></div>';
          }
        });
        $('.form_details').html(fieldHtml);
        $('.product-form').addClass('quote-form');
        $('.product-form .product__add-to-cart-button').removeAttr('disabled', false);
        $('.final-total').hide();
        $('.accept-terms').hide();
      }else{
        if(hasValid == true && id != 0){
          hasNewReq = false;          
          $.ajax({
            url: serverURL+"api/get_submission_status",
            type: "GET",
            async:false,
            data: $.param({id:id}),
            dataType: 'json',
            crossDomain:true,
            success: function(r){
              console.log(r);
              if(r.status == 404){
                hasNewReq = true;
                hasApprove = false;
                
                
                var fieldHtml = '';
                $(d.fields).each(function(k,v){
                  if(v.status != '0'){
                    fieldHtml += '<div class="form-group" ><label class="hide" for="'+v.id+'-'+k+'">'+v.label+'</label><input class="form-control" data-label="'+v.label+'" name="details['+v.id+']" placeholder="'+v.label+'" data-validation="'+v.validation+'" type="text"></div>';
                  }
                });
                $('.form_details').html(fieldHtml);
                //$('<div class="status error"><p>No request founded. Create new one by filling below details.</p></div>').insertBefore('.form_details');
                //$('<div class="status error"><p>No request founded. Create new one by filling below details.</p></div>').insertBefore('.form_details');
                $('.form-status').html('<p class="error">No request founded. Create new one by filling below details.</p>');
                
                $('.product-form').addClass('quote-form');
                $('.product-form .product__add-to-cart-button').removeAttr('disabled', false);
                $('.final-total').hide();
                $('.accept-terms').hide();
              }else{
                if(r.data.is_approved == true && r.data.order_number == null){
                  hasApprove = true;
                  $('#aggrement_text').html('<p class="suceess">'+r.data.agreement_detail+'</p>');
                  $('.product-form').addClass('deposite-form');
                  $('#accept_terms').attr('disabled', true);
                  $('.product-form').append('<input type="hidden" name="properties[submission_id]" value="'+id+'">');
                }else{
                  hasNewReq = false;
                  hasApprove = false;
                }
              }
              
            }
          });
        }
      }
      console.log(hasApprove);
      console.log(hasNewReq);
      if(hasApprove == true || hasNewReq == true){
        //$('.product__title').text(d.event_title+' Registration');
        $('.product__title').text(d.event_title);
        /* Product Performer */
        var performer = '';
        $(d.performer).each(function(k,v){
          var d = v.available == 0 ? 'disabled': '';
          performer += '<li>'+
          '<span class="checkbox_box">'+
            //'<input type="checkbox" id="'+v.performer+'" name="properties[performer][]" value="'+v.performer+'">'+
            '<input '+d+' type="checkbox" id="'+v.performer+'" value="'+v.performer+'">'+
            '<label for="'+v.performer+'"> '+v.performer+'</label>'+
            '</span>'+
            '<span class="text_box">'+
            '<input disabled data-max="'+v.available+'" max="'+v.available+'" data-price="'+v.price+'" min="1" data-type="performer-'+v.performer+'" class="qty-input" type="number" name="properties[performer]['+v.performer+'][qty]">'+
            '<input disabled value="'+v.price+'" type="hidden" name="properties[performer]['+v.performer+'][price]">'+
            //'<label for="person"><strong>$'+v.price+'</strong> / person</label>'+
            '<label for="person"><strong>'+v.available+'</strong> / available</label>'+
            '<span></li>';
        });

        $('.performer-list').prepend(performer);
        
        if(d.event_allownonperformer == 'on'){
          $('.non_performer_block').removeClass('hide');
          $('.non_performer_block #Non-Performer').attr('disabled', false);
          $('.non_performer_block strong').text('$'+d.nonperformer_price);
          $('.non_performer_block input[type="number"]').attr('data-price', d.nonperformer_price);
          $('.non_performer_block input[type="number"]').attr('max', 200);
          $('.non_performer_block input[type="number"]').removeAttr('readonly');
          $('#non_performer_price').val(d.nonperformer_price);
        }else{
          $('.non_performer_block').hide();
        }

        if(d.event_allowspotlight == 'on'){
          //$('.performer-list li').removeClass('hide');
          $('.spotligt_block').removeClass('hide');
        }

        /* Hotels and Rooms Tab Section  */
        if (isAppleDevice()) {
          var hotelBookingStartDate = apple_date(d.event_hotelbookingstartdate);
          var hotelBookingEndDate = apple_date(d.event_startdate);
        }else{
          var hotelBookingStartDate = new Date(d.event_hotelbookingstartdate);
          var hotelBookingEndDate = new Date(d.event_startdate);
        }

        //var hotels = '';
        var roomsHtml = '';
        console.log();
        var hr = d.hotelrooms;
        if(hr.length > 0){
          for (var room in d.hotelrooms) {
            var roomDetail = d.hotelrooms[room];
            var roomDescription = roomDetail.name;
            var roomImage = roomDetail.img;

            roomsHtml += '<li>'+
              '<input class="expenseCheckbox" value="'+roomDetail.name+'" name="properties[rooms]['+roomDetail.name+']" type="checkbox">'+
              '<span class="hotel-picture"><img src="'+imgServerURL+roomDetail.img+'" alt=""></span>'+
              //'<span class="hotel-picture"><img src="" alt=""></span>'+
              '<span class="hotel_info">'+
              '<strong>'+roomDetail.name+'</strong>'+roomDescription+
              '</span>';
            roomsHtml += '</li>';
          }
          $('.room-list').html(roomsHtml);
        }else{
          $('.select_hotel_block').hide();
        }

        /*var c = 1;
        for (var hotel in d.hotels) {
          var hotelDetail = d.hotels[hotel];
          var hotelDescription = hotelDetail.hotel_description;
          hotels += '<div class="hotel_coll">'+
            //'<input type="radio" data-id="'+c+'" class="hotel-tabs" id="tab'+c+'" value="'+hotelDetail.hotel_name+'" name="properties[hotel]">'+
            '<input type="radio" data-id="'+c+'" class="hotel-tabs" id="tab'+c+'" value="'+hotelDetail.hotel_name+'" name="properties[hotel]">'+
            '<div class="check_box">'+
            '<div class="tab_img"><img src="'+imgServerURL+hotelDetail.hotel_image+'" alt=""></div>'+
            '<label for="tab'+c+'"><strong>'+hotelDetail.hotel_name+'</strong> '+hotelDescription+'</label>'+
            '</div>'+
            '</div>';

          var rooms = '';
          $(d.hotels[hotel].rooms).each(function(k,v){
            rooms += '<li>'+
              '<span class="checkbox-hotel"><input type="radio" class="hotel_room" name="properties[hotels]['+hotelDetail.hotel_name+'][room]" id="room-'+hotelDetail.id+'-'+k+'" value="'+v.room+'"></span>'+
              '<label for="room-'+hotelDetail.id+'-'+k+'" class="hotel_info"><strong>$'+v.price+'</strong> / person '+v.room+'</label>'+
              '<span class="room_number"><input disabled readonly class="qty-input" min="1" name="properties[hotels]['+hotelDetail.hotel_name+'][qty]" data-type="hotel-room" data-price="'+v.price+'" type="number" data-max="'+v.quantity+'" max="'+v.quantity+'"></span>'+
              '<input readonly value="'+v.price+'" type="hidden" name="properties[hotels]['+hotelDetail.hotel_name+'][price]">'+
              '</li>';
          });
          roomsHtml += '<article class="tab-content" id="tab-content-'+c+'"><div class="top_hotel"><ul class="hotel_room_details">'+rooms+'</ul></div></article>';
          c = c+1;
        }

        $('.hotel-listing').html(hotels);
        $('.hotel-rooms-listing').html(roomsHtml);*/

        /* Expense Details */
        var expenseHTML = '';
        for (var expense in d.expenses) {
          var expenseDetail = d.expenses[expense];
          var expenseDescription = expenseDetail.description;
          //var expenseArr = expenseDetail.expense;

          expenseHTML += '<li>'+
            '<input class="expenseCheckbox" value="'+expenseDetail.name+'" name="properties[expenses]['+expenseDetail.name+']" type="checkbox">'+
            '<span class="hotel-picture"><img src="'+imgServerURL+expenseDetail.img+'" alt=""></span>'+
            '<span class="hotel_info">'+
            '<strong>'+expenseDetail.name+'</strong>'+expenseDescription+
            '</span>';

          var expensesHTML = '';

          /*if(expenseArr.length > 0){
            $(d.expenses[expense].expense).each(function(k,v){
              expensesHTML += '<li>'+
                '<span class="checkbox-subexpense"><input data-type="expense-'+expenseDetail.expense_name+'" data-price="'+v.price+'" id="sub_expenses_'+v.sub_expense+'" disabled data-price="'+v.price+'" type="radio" name="properties[expenses]['+expenseDetail.expense_name+'][sub_expense]" value="'+v.sub_expense+'" ><label for="sub_expenses_'+v.sub_expense+'">'+v.sub_expense+'</label></span>'+
                '<input readonly value="'+v.price+'" type="hidden" name="properties[expenses]['+expenseDetail.expense_name+']['+v.sub_expense+'][price]">'+
                '<span class="subexpense_info"><strong>$'+v.price+'</strong></span>'+
                '</li>';
            });
            expenseHTML += '<ul class="sub-expenses-list">'+expensesHTML+'</ul>';
          }else{
            expenseHTML += '<span class="hotel_price"><strong>$'+d.expenses[expense].expense[0].price+'</strong></span>'
          }*/
          expenseHTML += '</li>';
        }
        if(expenseHTML != ''){
          $('.expenses-list').html(expenseHTML);
        }else{
          $('.malti_hotel_section').hide();
        }

        if(todayDate.getTime() >= hotelBookingStartDate.getTime()){
          $('.select_hotel_block').removeClass('hide');
          $('.malti_hotel_section').removeClass('hide');
        }else{
          $('.select_hotel_block').addClass('hide');
          $('.malti_hotel_section').addClass('hide');
        }

        /* Others */
        if (isAppleDevice()) {
          var eventBookingStartDate = apple_date(d.event_bookingstartdate);
          var eventBookingEndDate = apple_date(d.event_bookingenddate);
        }else{
          var eventBookingStartDate = new Date(d.event_bookingstartdate);
          var eventBookingEndDate = new Date(d.event_bookingenddate);
        }
        
        if((todayDate.getTime() <= eventBookingEndDate.getTime() && todayDate.getTime() >= eventBookingStartDate.getTime())){
          $('.select_hotel_block').removeClass('hide');
          $('.malti_hotel_section').removeClass('hide');
          $('.booking_part').removeClass('hide');
        }else{
          $('.booking_part').addClass('hide');
          $('.booking_part').html('<p>Comming soon</p>');
        }
        
        if(d.event_allowexpenses == 'on'){
          
        }else{
          $('.select_hotel_block, .malti_hotel_section').hide();
        }
        
      }else{
        //$('.form_details').append('<div class="status success"><p>Your Request accepted and order has been generated, wait for the final payment mail.</p></div>');
        $('.form-status').html('<p class="success">Your Request accepted and order has been generated, wait for the final payment mail.</p>');
      }
      
      $('body').removeClass('loader');
    }
  });
  
  var totalPrice = 0;
  var totalPriceArr = [];
  $(document).on('keyup change mouseup', 'input[type="number"]', function(){
    var attr = $(this).attr('data-price');
    
    var min = $(this).attr('min');
    var max = parseInt($(this).attr('max'));
    //console.log(min);
    //console.log(max);
    
    if($.isNumeric( $(this).val() ) && typeof attr !== 'undefined' && attr !== false){
      var val = parseInt($(this).val());

      var check = true;
      /*console.log(max);
      console.log(val);*/
      if(max >= val ){
      }else{
        check = false;
      }
      if(min <= val ){
      }else{
        //check = false;
        $(this).val(min);
      }

      //console.log(check);
      if(check == true){
        //var price = parseFloat($(this).data('price'));
        var type = $(this).data('type');
        if($(this).parents('ul').hasClass('performer-list') || type ==  'non-performer'){
          var price = 100;
        }else{
          
        }        
        
        totalPriceArr[type] = val*price;
      }else{
        $(this).val(max);
      }
    }else{
      
    }
    //console.log(totalPriceArr);
    generateFinalTotal(totalPriceArr);
  });
  
  /* Radio button changing  */
  $(document).on('change', 'input[type="radio"]', function(){
    var attr = $(this).attr('data-price');
    var name = $(this).attr('name');
    
    if(typeof attr !== 'undefined' && attr !== false){
      //console.log($(this).data('price'));
      var price = parseFloat($(this).data('price'));
      totalPriceArr[$(this).data('type')] = price;
      //console.log(totalPriceArr);      
    }
    //console.log(totalPriceArr);
    generateFinalTotal(totalPriceArr);
            
    
    if($(this).is(':checked')) {
      $(this).parents('li').find('.qty-input').removeAttr('disabled');
      if($(this).hasClass('hotel_room')){
        $('.hotel_room_details').find('.qty-input').val('');
        $('.hotel_room_details').find('.qty-input').attr('disabled', true);
        $(this).parents('li').find('.qty-input').attr('disabled', false);
      }
    }else{
      $(this).parents('li').find('.qty-input').attr('disabled', true);
    }
  });
  
  $(document).on('change', 'input[type="checkbox"]', function(){
    var attr = $(this).attr('data-price');
    var name = $(this).attr('name');
    
    //$('#product_id').val();
    if($(this).val() == 'spotlight'){
      var v = $('#product_id').val();
      if($(this).is(':checked')){
        //window.open("https://www.nationalconcerts.com/products/spotlight-performer?event_id="+v);
      }      
    }
    if(name == 'non_performer'){ 
      if($(this).is(':checked')){
        $('.non_performer_block input[type="number"]').attr('disabled', false);
      }else{
        $('.non_performer_block input[type="number"]').attr('disabled', true);
      }
    }
    
    if(typeof attr !== 'undefined' && attr !== false){
      if(this.checked) {
        var price = parseFloat($(this).data('price'));
        totalPriceArr[$(this).data('type')] = price;
      }else{
        delete totalPriceArr[$(this).data('type')];
      }
      //console.log(totalPriceArr);
      generateFinalTotal(totalPriceArr);
    }
    
    //console.log($(this).parent('li').find('.sub-expenses-list').length);
    //console.log($(this).parent('li').find('.sub-expenses-list').find('input[type="radio"]').is(':checked'));
    if(this.checked) {
      $(this).parents('li').find('.qty-input').removeAttr('disabled');
      $(this).parents('li').find('input[type=radio]').removeAttr('disabled');
      
      if($(this).parent('li').find('.sub-expenses-list').length > 0){
        $(this).parent('li').find('.sub-expenses-list').find('li').eq(0).find('input[type=radio]').prop('checked', true);
        var t = $(this).parent('li').find('.sub-expenses-list').find('li').eq(0).find('input').data('type');
        var price = parseFloat($(this).parent('li').find('.sub-expenses-list').find('li').eq(0).find('input[type=radio]').data('price'));
        totalPriceArr[t] = price;
      }
    }else{
      $(this).parents('li').find('.qty-input').attr('disabled', true);
      $(this).parents('li').find('input[type=radio]').attr('disabled', true);
      
      //console.log($(this).parent('li').find('.sub-expenses-list').length);
      if($(this).parent('li').find('.sub-expenses-list').length > 0){
        $(this).parent('li').find('.sub-expenses-list').find('input[type=radio]:checked').prop('checked', false);
        //$(this).parent('li').find('.sub-expenses-list').find(':checkbox').attr('checked', false);
      }
      var t = $(this).parent('li').find('.sub-expenses-list').find('li').eq(0).find('input').data('type');
      delete totalPriceArr[t];
    }
  });

  /* Accept terms */  
  $('#accept_terms').on('change', function(){
    /*console.log(this.checked);
    console.log(totalPriceArr);
    console.log(totalPriceArr.length);*/
    if($('.product-form').hasClass('quote-form')){
      $('.product__add-to-cart-button').attr('disabled', false);
    }else{
      var i = Object.keys(totalPriceArr).length

      if(this.checked && i > 0) {
        //console.log(true);
        $('.product__add-to-cart-button').attr('disabled', false);
      }else{
        //console.log(false);
        $('.product__add-to-cart-button').attr('disabled', true);
      }  
    }
    
  });
  
  
  /* Form Submit for event */
  $('.product-form').on('submit', function(e){
    e.preventDefault();
    var formData = $(this).serializeArray();
    console.log(formData);
    if($(this).hasClass('deposite-form')){
      $.ajax({
        url: serverURL+"api/submit_event",
        type: "POST",
        beforeSend: function() {
          // setting a timeout
          $('body').addClass('loader');
        },
        dataType:'json',
        data: formData,
        crossDomain:true,
        success: function(response){
          console.log(response);
          if(response.status == true){
            location.href=response.checkout_url;
          }
          $('body').removeClass('loader');
        }
      });
    }else{



      $('.form-error').remove();
      var formData = $(this).serializeArray();

      var isValidate = true;
      $('.form_details .form-group').each(function(k,v){
        var val = $(v).find('.form-control').val();
        var name = $(v).find('.form-control').data('label');
        var validation = $(v).find('.form-control').data('validation');
        /*if($(v).find('select').length > 0 && $(v).find('select').val() == ''){
          $(v).append('<p class="form-error">Please select event</p>');        
        }*/

        if(validation != undefined){
          var validationArr = validation.split('|');
          //console.log(validationArr);
          if(validationArr.indexOf('require') > -1){
            if(val == ''){
              isValidate = false;
              $(v).append('<p class="form-error">Please fill out '+name+' field.</p>');
            }
          }

          if(validationArr.indexOf('email') > -1 && val != ''){
            var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(!regex.test(val)){
              isValidate = false;
              $(v).append('<p class="form-error">Please enter valid email address</p>');
            }
          }

          if(validationArr.indexOf('phone') > -1 && val != ''){
            var filter = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
            if (filter.test(val)) {
              //return true;
            }else{
              isValidate = false;
              $(v).append('<p class="form-error">Please enter valid Phone Number</p>');
            }
          }

          if(validationArr.indexOf('url') > -1 && val != ''){
            var regex = /^(http|https|ftp):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
            if (!regex.test(val)){
              isValidate = false;
              $(v).append('<p class="form-error">Please enter valid URL</p>');
            }          
          }
        }            
      });
      
      if(isValidate == true){
        $.ajax({
          url: serverURL+"api/submit_event_details",
          type: "POST",
          data: formData,
          beforeSend: function() {
            // setting a timeout
            $('body').addClass('loader');
          },
          dataType:'json',
          crossDomain:true,
          success: function(response){
            //console.log(response);
            if(response.status == true){
              $('.form-status').html('<p class="suceess">'+response.message+'</p>');
              $('.product-form')[0].reset();
              $(this).trigger("reset");
              $("html, body").animate({ scrollTop: 0 }, "slow");
              //location.href=response.checkout_url;
            }else{
              $('.form-status').html('<p class="error">'+response.message+'</p>');
              $("html, body").animate({ scrollTop: 0 }, "slow");
            }
            $('body').removeClass('loader');
          }
        });
      }else{
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
        //$('.error-wrapper').html('<p>Please fill the required fields.</p>');
      }
    }
  });
});